import React from "react";
import classnames from 'classnames';
import backgrounds from "./assets.json";
import { pickIndex } from "../../utils/array";
import * as s from "./Background.module.css";

const Background = React.forwardRef((props ,ref)=> {
    const { className, width, height, children, disablePaddles, onBackgroundChange,...rest} = props;
    const backgroundIndex = props.background;
    const setBackgroundIndex = index => onBackgroundChange && onBackgroundChange(index);
    const prevIndex = () => setBackgroundIndex((backgroundIndex-1+backgrounds.length)%backgrounds.length);
    const nextIndex = () => setBackgroundIndex((backgroundIndex+1)%backgrounds.length);
    return (
        <div className={classnames(s['root'], disablePaddles && s['disable-paddles'])}>
        <div
            className={classnames(s["image"], className)}
            ref={ref}
            style={{
                width: width ? `${width}px` : "100%",
                height: height ? `${height}px` : "100%",
                backgroundImage: `url(/images/scenery/${backgrounds[backgroundIndex]})`,
            }}
        {...rest}
        >
            {children}
        </div>
        <div className={s['left-paddle']} onClick={prevIndex}>
            <div className={s['paddle']}></div>
        </div>
        <div className={s['right-paddle']} onClick={nextIndex}>
            <div className={s['paddle']}></div>
        </div>
        </div>
    );
});

export default Background;
